import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import type MarketSettingsCentralMappingRoute from 'lumen/routes/market/settings/central-mapping';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSettingsCentralMappingSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<MarketSettingsCentralMappingRoute>;
  };
}

<template>
  <div class="central-mapping">
    {{#if @model.breakdowns.isRunning}}
      <PrismLoadingBar />
    {{/if}}

    {{outlet}}
  </div>
</template> satisfies TOC<MarketSettingsCentralMappingSignature>;
